module.exports = __webpack_public_path__ + "img/gsb.5e0bddc8.jpg";